import { Component, OnInit } from '@angular/core';
import {Paiement} from "../../booking/paiement";
import {FonctionUtiles} from "../../fonctionsUtiles";
import {BooKingservice} from "../../booking/booking.service";
import {AuthService} from "../../../core/auth/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {BookingList} from "../../event/bookingList";
import {Pricing} from "../../booking/pricing";
import {Order} from "../../booking/order";
import {Ticket} from "../../booking/ticket";
import {FoEventsService} from "../../event/foevents.service";

@Component({
  selector: 'app-payment-confirm',
  templateUrl: './payment-confirm.component.html',
  styleUrls: ['./payment-confirm.component.css']
})
export class PaymentConfirmComponent implements OnInit {

  order : Order;
  tickets : Ticket[] = [];
  bookingLists : BookingList[] = [];
  pricings : Pricing[] = [];
  event : any;
  ticket : any;
  dayname : string;
  hours : number;
  day : number;
  month : string;
  condition : boolean = false;
  paiement : Paiement;
  onloading : boolean = false;
  error : boolean = false;
  Total : any;
  nbreTicket : number = 0;
  frais : number = 0;
  devise : string;
  days : any;
  daysarray = ' ';
  months = ' ';
  expirationTime:number;
  codePromosActivated:any=[];
  sessionExpirationTime

  constructor(  private eventservice: FoEventsService,private bookingservice:BooKingservice,private router :Router, private translateService:TranslateService,public functionUtils:FonctionUtiles,private authservice:AuthService) {
    this.expirationTime = this.bookingservice.retrieve('sessionExpirationTime');
  }

  setDevises(event)
  {
    if(event.currency) {
      this.devise = event.currency
    }
    else {
      this.devise = 'Eur'
    }
  }

  ngOnInit() {
    this.event = this.bookingservice.retrieve('event');
    let debut = (this.event.start_date+' '+this.event.start_hour);
    let d = new Date(debut.replace(/ /g,"T"));
    this.initTranslation(d);
    this.retriveFormStorageAndInitComponentElements();
    this.dayname = '  '+this.daysarray[d.getDay()];
    this.hours = d.getHours();
    this.day = d.getDate();
    this.month = this.months[d.getMonth()];
    this.paiement = new Paiement();

  }


  retriveFormStorageAndInitComponentElements() {
    this.event = this.bookingservice.retrieve('event');
    this.ticket = this.bookingservice.retrieve('inscriptionTicket');
    this.sessionExpirationTime = this.bookingservice.retrieve('sessionExpirationTime');
    console.log(this.ticket)
    this.setDevises(this.ticket.event);
  }

  initTranslation(d)
  {
    this.translateService.get('front_booking_payment.daysarray').subscribe(
      value => {
        this.daysarray = value.split(',');
        this.dayname = value.split(',')[d.getDay()];
      }
    );

    this.translateService.get('front_booking_payment.months').subscribe(
      value => {
        this.months = value.split(',');
      });

  }







  displayTotal(total) {
    if(total==0) {
      return 'Gratuit'
    }
    else {
      return total+' '+this.functionUtils.getPricingDeviseSymbole(this.devise);
    }
  }





  getPricingPrice(pricing) {
    return this.functionUtils.getPricingPrice(pricing);
  }


  retour() {
    window.history.back();
  }




  valider() {
    this.eventservice.ValidateAndPay(this.ticket).then(res=> {
        let payment = res.payment;
        let form = document.createElement("form");
        form.method = "POST";
        form.action = payment.endpoint;
        Object.keys(payment.form).forEach(function (key) {
          let element = document.createElement("input");
          element.type = "hidden";
          element.value = payment.form[key];
          element.name = key;
          form.appendChild(element);
        });
        document.body.appendChild(form);
        if(res.order.total_price > 0)
          form.submit();
        else
          this.moveToSuccess();

    })

  }

  moveToSuccess() {
    this.router.navigate(['inscription/payment/success']);
  }


}
